exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".teams-component{background:#f5f5f5}.teams-component .card{background:#fff;margin-bottom:15px;padding:15px 10px}.teams-component .card .cat{font-size:10px;color:#6b8e23}.teams-component .date>div{margin:auto;min-height:calc(100vw - 50px)}@media only screen and (min-width:600px){.teams-component .date>div{min-height:343px}}.teams-component .teams{padding:15px;min-height:calc(100vh - 343px)}.teams-component .teams .team{display:block;color:rgba(0,0,0,.65);border:1px solid #ddd;position:relative;margin-bottom:10px;width:100%}.teams-component .teams .team img{height:200px;width:100%;object-fit:cover}@media only screen and (min-width:600px){.teams-component .teams .team img{height:90%}}.teams-component .teams .team .title{padding:10px;text-align:justify}.teams-component .teams .team .time{padding:0 10px 10px}.teams-component .teams .team .price{color:#fff;position:absolute;right:10px;top:175px}@media only screen and (min-width:600px){.teams-component .teams .team .price{top:10px}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader?outputStyle=expanded!./src/develop/Teams.scss
// module id = 617
// module chunks = 0